export const MODULE_NAME = 'DASHBOARD_KPIS_MODULE';

export function getModuleName(): string {
  return MODULE_NAME;
}
